import { UAParser } from 'ua-parser-js';

export type OperatingSystem = 'mac' | 'windows' | 'linux';

export const detectBrowserOperatingSystem = (): OperatingSystem => {
  if (typeof navigator === 'undefined') {
    return 'mac';
  }

  const osName = new UAParser(navigator.userAgent).getOS().name?.toLowerCase();

  if (osName?.includes('windows')) {
    return 'windows';
  }

  if (osName?.includes('linux')) {
    return 'linux';
  }

  return 'mac';
};
